<template>
  <v-layout>
    <v-flex>
      <v-form ref="form" v-model="valid">
        <v-text-field
          v-if="expense.id !== undefined"
          label="ID"
          v-model="expense.id"
          disabled
        >
        </v-text-field>

        <v-text-field
          label="Document nr"
          v-model="expense.documentNr"
          :rules="requiredRule"
          required
        ></v-text-field>

        <v-text-field label="Explicatie" v-model="expense.description">
        </v-text-field>

        <v-text-field
          label="Suma"
          v-model="expense.amount"
          :rules="requiredNumberRules"
          required
        >
        </v-text-field>

        <v-menu
          ref="menuDate"
          v-model="menuDate"
          :close-on-content-click="false"
          :return-value.sync="expense.date"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="expense.date"
              label="Data interventie"
              prepend-icon="event"
              readonly
              v-on="on"
              :rules="requiredRule"
            ></v-text-field>
          </template>
          <v-date-picker v-model="expense.date" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="menuDate = false">Cancel</v-btn>
            <v-btn
              text
              color="primary"
              @click="$refs.menuDate.save(expense.date)"
              >OK</v-btn
            >
          </v-date-picker>
        </v-menu>

        <v-select label="Tipul Platii" v-model="expense.paymentType" :items="paymentTypes" :rules="requiredRule" required>
        </v-select>

        <v-switch label="Contine TVA" v-model="expense.containsVAT" class="mx-2"></v-switch>

        <v-switch label="Reprezinta Depunere incasari" v-model="expense.isCashDeposit" class="mx-2"></v-switch>

        <div class="text-xs-right">
          <v-btn @click="submit" color="primary">Salvare</v-btn>
        </div>
      </v-form>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: ['expense', 'onSubmit'],
  data() {
    return {
      valid: true,
      menuDate: false,
      requiredRule: [
        (element) => {
          if (!element || element.trim() === '') return 'Campul trebuie completata.';
          return true;
        },
      ],
      requiredNumberRules: [
        (element) => {
          // eslint-disable-next-line no-restricted-globals
          if (!element || isNaN(Number(element))) { return 'Campul trebuie completat'; }
          return true;
        },
      ],
      paymentTypes: ['cash', 'card', 'op'],
    };
  },
  methods: {
    submit() {
      if (this.$refs.form.validate() && this.valid) {
        this.onSubmit();
      }
    },
  },
};
</script>

<style>
</style>
